import { useWindowSize } from 'rooks';
import { largeScreenMinWidth, smallScreenMaxWidth } from '../../../common/utilities/sizeHelpers';

type DeviceScreenSizeResult = {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    deviceTypeKey: string;
};

export const useDevice = () => {
    const { innerWidth } = useWindowSize();

    const result: DeviceScreenSizeResult = {
        isMobile: false,
        isTablet: false,
        isDesktop: false,
        deviceTypeKey: 'desktop'
    };

    if (!innerWidth) {
        return result;
    }

    result.isMobile = innerWidth <= smallScreenMaxWidth;
    result.isTablet = innerWidth > smallScreenMaxWidth && innerWidth < largeScreenMinWidth;
    result.isDesktop = innerWidth >= largeScreenMinWidth;

    if (result.isMobile) {
        result.deviceTypeKey = 'mobile';
    }
    if (result.isTablet) {
        result.deviceTypeKey = 'tablet';
    }
    if (result.isDesktop) {
        result.deviceTypeKey = 'desktop';
    }

    return result;
};
